// src/stores/kingdeeStore.ts
import {defineStore} from 'pinia'
import {ref} from 'vue'
import {Purchase, TbReconDto} from "@/types/common";

// 销售出库单VO
export interface SaleOutReceiptVo {
    billNo?: string;
    proceedStatus?: number;
    reconStatus?: string;
    reconAmount?: number;
    billDate?: string;
    customerName?: string;
    customerId?: number;
    salespersonId?: number;
    salespersonName?: string;
    actualPayAmount?: number;
    firstReceiptBillNo?: string;
    depId?: number;
    depName?: string;
    busiTypeName?: string;
    logNo?: string;
    _checked?: boolean;
    entitys?: SaleOutReceiptEntityDto[]
}
// 销售出库单明细
export interface SaleOutReceiptEntityDto {
    entryId?: number
    materialNumber?: string
    productName?: string
    materialModel?: string
    basicUnit?: string
    auxiliaryUnit?: string
    qty?: number
    secQty?: number
    consignAmount?: number // 单商品金额
    stockName?: string
}

export const useKingdeeStore = defineStore('kingdee', () => {
    // ========== 采购入库单相关 ==========
    const cgrkListPageNumber = ref<number>(1)
    const currentPurchase = ref<Purchase>({
        billNo: '',
        billDate: '',
        supplyName: '',
        deptName: '',
        empName: '',
        reconStatus : '',
        reconAmount: 0,
        entitys: []
    })
    const selectedPurchaseList = ref<Purchase[]>([])
    const purchaseList = ref<Purchase[]>([])
    const cgrkListPageParams = ref({
        pageNum: 1,
        billNo: '',
        salespersonName: '',
        supplyName: '',
        startDate: '',
        isReceivable: undefined as 0 | 1 | undefined
    })
    // ========== 采购入库单方法 ==========
    const setPurchaseList = (list: Purchase[]) => {
        purchaseList.value = list
    }
    const setCgrkListPageParams = (data: any) => {
        cgrkListPageParams.value = data
    }
    const setCgrkListPageNumber = (pageNumber: number) => {
        cgrkListPageNumber.value = pageNumber
    }
    const setCurrentPurchase = (receipt: Purchase) => {
        currentPurchase.value = receipt
    }
    const setSelectedPurchaseList = (list: Purchase[]) => {
        selectedPurchaseList.value = list
    }
    const clearPurchaseData = () => {
        purchaseList.value = []
        currentPurchase.value = {
            billNo: '',
            billDate: '',
            supplyName: '',
            deptName: '',
            empName: '',
            reconStatus : '',
            reconAmount: 0,
            entitys: []
        }
        selectedPurchaseList.value = []
        cgrkListPageNumber.value = 1
        cgrkListPageParams.value = {
            pageNum: 1,
            billNo: '',
            salespersonName: '',
            supplyName: '',
            startDate: '',
            isReceivable: undefined
        }
    }
    // ========== 销售出库单相关 ==========
    const xsckListPageNumber = ref<number>(1)
    const saleOutReceiptList = ref<SaleOutReceiptVo[]>([])
    const currentSaleOutReceipt = ref<SaleOutReceiptVo>({})
    const selectedSaleOutList = ref<SaleOutReceiptVo[]>([])
    const xsckListPageParams = ref({
        pageNum: 1,
        billNo: '',
        salespersonName: '',
        customerName: '',
        startDate: '',
        endDate: '',
        isReceivable: undefined as 0 | 1 | undefined,
        receivableStatus: undefined as 1 | 2 | 3 | undefined,
        busiTypeName: '' as string | undefined,
        firstReceiptBillNo: '',
        deptName: '',
        reconStatus: undefined as string | undefined
    })
    // ========== 销售出库单方法 ==========
    const setXsckListPageParams = (data: any) => {
        xsckListPageParams.value = data
    }
    const setXsckListPageNumber = (pageNumber: number) => {
        xsckListPageNumber.value = pageNumber
    }
    const setSaleOutReceiptList = (list: SaleOutReceiptVo[]) => {
        saleOutReceiptList.value = list
    }
    const setCurrentSaleOutReceipt = (receipt: SaleOutReceiptVo) => {
        currentSaleOutReceipt.value = receipt
    }
    const setSelectedSaleOutList = (list: SaleOutReceiptVo[]) => {
        selectedSaleOutList.value = list
    }
    const clearSaleOutReceiptData = () => {
        saleOutReceiptList.value = []
        currentSaleOutReceipt.value = {}
        selectedSaleOutList.value = []
        xsckListPageNumber.value = 1
        xsckListPageParams.value = {
            pageNum: 1,
            billNo: '',
            salespersonName: '',
            customerName: '',
            startDate: '',
            endDate: '',
            isReceivable: undefined,
            receivableStatus: undefined as 1 | 2 | 3 | undefined,
            busiTypeName: '' as string | undefined,
            firstReceiptBillNo: '',
            deptName: '',
            reconStatus: undefined as string | undefined
        }
    }
    // ========== 对账单相关 ==========
    const reconPageParams = ref({
        pageNum: 1,
        reconCode: '',
        salespersonName:  '',
        startDate: '',
        endDate: '',
    })
    const reconData = ref<TbReconDto>({})
    // ========== 对账单相关方法 ==========
    const setReconDataType = (type: number) => {
        reconData.value.reconType = type
    }
    const setReconData = (data: TbReconDto) => {
        reconData.value = data
    }
    const setReconPageParamss = (data: any) => {
        reconPageParams.value = data
    }
    const clearReconPagetData = () => {
        reconPageParams.value = {
            pageNum: 1,
            reconCode: '',
            salespersonName: '',
            startDate: '',
            endDate: '',
        };
        reconData.value = {};
    }
    // ========== 通用方法 ==========
    const clearPageNumber = () => {
        xsckListPageNumber.value = 1
    }

    return {
        // 采购入库单状态
        purchaseList,
        cgrkListPageParams,
        cgrkListPageNumber,
        currentPurchase,
        selectedPurchaseList,
        // 采购入库单方法
        setPurchaseList,
        setCgrkListPageNumber,
        setCurrentPurchase,
        setSelectedPurchaseList,
        clearPurchaseData,
        setCgrkListPageParams,
        // 销售出库单状态
        xsckListPageNumber,
        saleOutReceiptList,
        currentSaleOutReceipt,
        selectedSaleOutList,
        xsckListPageParams,
        // 销售出库单方法
        setXsckListPageNumber,
        setSaleOutReceiptList,
        setCurrentSaleOutReceipt,
        setSelectedSaleOutList,
        clearSaleOutReceiptData,
        setXsckListPageParams,
        // 对账单状态
        reconPageParams,
        reconData,
        // 对账单方法
        setReconPageParamss,
        clearReconPagetData,
        setReconData,
        setReconDataType,
        // 通用
        clearPageNumber,
    }
})